// extracted by mini-css-extract-plugin
export var container = "Video-module--container--rHy7x";
export var inner = "Video-module--inner--c8C26";
export var isPlaying = "Video-module--isPlaying--kKHic";